import React from "react";
import PropTypes from "prop-types";

const ScooterSVG = ({ viewBox, width, height, color }) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={width} height={height}/>
    <g id="Vector">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 4.65C2.56812 4.65 4.65 2.56812 4.65 0H6.15C6.15 3.39655 3.39655 6.15 0 6.15V4.65Z" fill="#A9ACB6"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M16.046 13.1247V3.49227C16.046 3.21995 15.8289 3 15.5601 3H12.9656C12.6969 3 12.4798 3.21995 12.4798 3.49227C12.4798 3.76459 12.6969 3.98454 12.9656 3.98454H15.0709V11.1242C13.3136 11.3476 11.9182 12.7581 11.6977 14.5387H5.80576C5.56458 12.5975 3.92794 11.0893 1.94674 11.0893C1.67799 11.0893 1.46092 11.3092 1.46092 11.5815C1.46092 11.8539 1.67799 12.0738 1.94674 12.0738C3.39043 12.0738 4.58604 13.1421 4.82033 14.5387H3.82457C3.6075 13.6903 2.84948 13.0618 1.94329 13.0618C0.871726 13.0618 0 13.9451 0 15.0309C0 16.1167 0.871726 17 1.94329 17C2.84603 17 3.6075 16.3716 3.82457 15.5232H12.1525C12.4212 15.5232 12.6383 15.3032 12.6383 15.0309C12.6383 13.5681 13.6926 12.3566 15.0709 12.1192V13.1247C14.2336 13.3446 13.6134 14.1127 13.6134 15.0309C13.6134 16.1167 14.4851 17 15.5567 17C16.6283 17 17.5 16.1167 17.5 15.0309C17.5034 14.1162 16.8832 13.3446 16.046 13.1247ZM1.94333 16.0152C1.40583 16.0152 0.971688 15.5718 0.971688 15.0306C0.971688 14.486 1.40927 14.0461 1.94333 14.0461C2.30167 14.0461 2.61177 14.2451 2.7806 14.5384H1.94333C1.67458 14.5384 1.45751 14.7583 1.45751 15.0306C1.45751 15.303 1.67458 15.5229 1.94333 15.5229H2.7806C2.61177 15.8162 2.30167 16.0152 1.94333 16.0152ZM14.5886 15.031C14.5886 15.5722 15.0228 16.0155 15.5603 16.0155C16.0943 16.0155 16.5319 15.5756 16.5319 15.031C16.5319 14.6679 16.3355 14.3537 16.0461 14.1826V15.031C16.0461 15.3033 15.829 15.5233 15.5603 15.5233C15.2915 15.5233 15.0744 15.3033 15.0744 15.031V14.1826C14.785 14.3537 14.5886 14.6679 14.5886 15.031Z" fill={color}/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 8.25C4.55635 8.25 8.25 4.55635 8.25 0H9.75C9.75 5.38478 5.38478 9.75 0 9.75V8.25Z" fill={color}/>
      <path d="M2.7 0C2.7 1.49117 1.4912 2.7 6.13675e-05 2.7L0 5.52535e-06L2.7 0Z" fill={color}/>
    </g>
    </svg>
  );

ScooterSVG.propTypes = {
  viewBox: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

ScooterSVG.defaultProps = {
  viewBox: "",
  width: "",
  height: "",
  color: "",
};

export default ScooterSVG;
